/** Canonical production origin — import this instead of re-typing the literal. */
export const SITE_ORIGIN = 'https://mystudyfund.com';
